<template>
  <div>
    <div style="margin: 4rem 3rem">
      <div class="form-group">
        <label for="locale">Country</label>
        <select
          id="locale"
          v-model="locale"
          name="locale"
          class="form-control"
          @change="handleLocaleSelect"
        >
          <option :value="null" disabled selected>
            -- Select manufacturer country --
          </option>
          <option
            v-for="(localeOption, l) in manufacturer.locales"
            :key="l"
            :value="localeOption.id"
          >
            {{ localeOption.country }}
          </option>
        </select>
      </div>
    </div>
    <div style="margin: 4rem 3rem; max-height: 500px; overflow-y: auto">
      <table class="table table-striped table-bordered" style="width: 100%">
        <thead>
          <tr>
            <td></td>
            <td><b>Company Name</b></td>
            <td><b>Location</b></td>
          </tr>
        </thead>
        <tbody v-if="locale == null">
          <tr>
            <td colspan="3" style="text-align: center">
              Select country to load available QuickBooks Vendors
            </td>
          </tr>
        </tbody>
        <tbody v-else-if="loadingManufacturers">
          <tr>
            <td colspan="3" style="text-align: center">Loading Vendors...</td>
          </tr>
        </tbody>
        <tbody v-else-if="manufacturers.length === 0">
          <tr>
            <td colspan="3" style="text-align: center">
              No QuickBooks Vendors available...
            </td>
          </tr>
        </tbody>
        <tbody v-else style="max-height: 500px; overflow-y: scroll">
          <tr v-for="(manufacturer, m) in manufacturers" :key="m">
            <td style="text-align: center">
              <input
                :id="'qbo-manufacturer-' + manufacturer.Id"
                v-model="selectedManufacturer"
                name="qbo-manufacturer"
                type="radio"
                :value="manufacturer.Id"
                style="cursor: pointer"
                :title="'Select ' + manufacturer.DisplayName"
              />
            </td>
            <td>
              <label :for="'qbo-manufacturer-' + manufacturer.Id">
                {{ manufacturer.DisplayName }}
              </label>
            </td>
            <td v-if="manufacturer.BillAddr">
              {{
                manufacturer.BillAddr.City
                  ? manufacturer.BillAddr.City + ", "
                  : ""
              }}
              {{
                manufacturer.BillAddr.CountrySubDivisionCode
                  ? manufacturer.BillAddr.CountrySubDivisionCode
                  : ""
              }}
            </td>
            <td v-else></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-right">
      <button
        class="btn btn-primary"
        :disabled="selectedManufacturer === null"
        @click="handleNext"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import store from "../../../../store/stores";

export default {
  store,
  computed: {
    ...mapState(["manufacturer"]),
    locale: {
      set(value) {
        this.$store.commit("manufacturer/SET_LOCALE", value);
      },
      get() {
        return this.manufacturer.selectedLocaleId;
      },
    },
    selectedManufacturer: {
      set(value) {
        this.$store.commit("manufacturer/SET_SELECTED_MANUFACTURER", value);
      },
      get() {
        return this.manufacturer.selectedManufacturer;
      },
    },
    ...mapGetters({
      manufacturers: "manufacturer/getManufacturers",
      loadingManufacturers: "manufacturer/getLoadingManufacturers",
    }),
  },
  methods: {
    handleLocaleSelect() {
      this.$store.dispatch("manufacturer/FETCH_TERMS");
      this.$store.dispatch("manufacturer/FETCH_MANUFACTURERS");
    },
    handleNext() {
      this.$emit("next");
    },
  },
};
</script>
